module.exports = __webpack_public_path__ + "d103c9b0642bf088f7b3708d5529382b.svg";